<template>
	<div>
		<input
				:type="isVisible ? 'text' : 'password'"
				:id="id"
				name="password"
				:class="classes"
				:style="inputStyle"
				minlength="6"
				required
				:placeholder="placeholder"
				:tabindex="tabIndex"
				@input="$emit('input', $event.target.value)"/>

		<span class="icon is-small is-clickable is-right" @click="isVisible = !isVisible" :style="passwordsValid ? 'margin-right: 10px;' : ''">
			<i v-if="isVisible" class="fa-solid fa-eye-slash" :style="validationIcon ? 'margin-top: 10px;' : ''"></i>
			<i v-else class="fa-solid fa-eye" :style="validationIcon ? 'margin-top: 10px;' : ''"></i>
			<i v-if="passwordsValid" style="margin: 10px 0 0 10px;" class="fa-solid fa-circle-check is-marged-right input-validation"></i>
		</span>

		<capslock-numlock-detector
				v-if="!disableCapslockNumlockDetector"
				:idTarget="id"
				:caps-lock-message="capsLockMessage"
				:num-lock-message="numLockMessage"/>
	</div>
</template>

<script>
import CapslockNumlockDetector from "./capslock-numlock-detector.vue";

export default {
	components: {CapslockNumlockDetector},
	props: {
		disableCapslockNumlockDetector: {
			type: Boolean,
			default: false
		},
		classes: String,
		inputStyle: String,
		capsLockMessage: {
			type: String,
			default: "CapsLock is on!"
		},
		numLockMessage: {
			type: String,
			default: "NumLock is on!"
		},
		tabIndex: {
			type: Number,
			required: false
		},
		placeholder: String,
		id: String,
		validationIcon: {
			type: Boolean,
			default: false,
			required: false
		},
		passwordsValid: {
			type: Boolean,
			default: false,
			required: false
		}
	},
	data() {
		return {
			isVisible: false
		}
	}
};
</script>
